export default __webpack_public_path__ + "c7b9c0f04aeb1c79aea770c9b91adbe4.png";